import { useColorTheme } from 'src/hooks';

export const AnthropicLogo = ({
  size = 20,
  color,
  colorReverse = false,
}: {
  size?: number;
  color?: 'white' | '#181818';
  colorReverse?: boolean;
}) => {
  const { isDarkTheme } = useColorTheme();
  const COLOR =
    color ||
    (isDarkTheme
      ? colorReverse
        ? '#181818'
        : 'white'
      : colorReverse
        ? 'white'
        : '#181818');

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1895_8237)">
        <path
          d="M9.01562 0.226562L12.9986 10.2392H15.1816L11.1986 0.226562H9.01562Z"
          fill={COLOR}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.77526 0.210938H7.05934L11.0377 10.2235H8.81185L7.99841 8.12175H3.83619L3.02122 10.2235H0.796875L4.77526 0.210938ZM4.55466 6.26047H7.28147L5.91807 2.74166L4.55466 6.26047Z"
          fill={COLOR}
        />
      </g>
      <defs>
        <clipPath id="clip0_1895_8237">
          <rect
            width="14.4"
            height="10.034"
            fill="white"
            transform="translate(0.796875 0.203125)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
